
import {
  messageTypes, MY_CODE_IS, JOIN_IN_ROOM, LEAVE_FROM_ROOM,
} from './types';
import {
  NODE_URL, INSTALLATION_CODE, MAX_ATTEMPTS_TO_RECONNECT,
} from './constants';

let __socket = null;
let __node_code = null;

export const init = (store, forceReconnect) => {
  if (__socket && !forceReconnect) {
    __socket.socket.connect({ autoconnect: true });
    return;
  }

  if (__socket && forceReconnect) {
    __socket.emit(messageTypes.FORCEDISCONNECT, {});
    return;
  }

  const state = store.getState();

  const { id: actual_user_id, node_code } = state.session.user;
  const { app: { id: instanceId } } = state;

  const user_code = node_code + node_code;

  if (!actual_user_id || !user_code) {
    return;
  }

  __socket = window.io(NODE_URL, {
    transports: ['websocket'],
    upgrade: false,
  });

  __node_code = node_code;

  Object.keys(messageTypes)
    .forEach((type) => {
      __socket.off(messageTypes[type]);
      __socket.on(messageTypes[type], (payload = {}) => {
        const newPayLoad = typeof payload === 'object' ? payload : {};
        newPayLoad.user_id = actual_user_id;
        newPayLoad.user_code = user_code;
        newPayLoad.instanceId = instanceId;

        store.dispatch({ type: messageTypes[type], payload: newPayLoad });

        switch (messageTypes[type]) {
          case messageTypes.WHATS_YOUR_CODE: {
            const user_code_small = user_code.substr(0, Math.round(user_code.length / 4));
            if (__socket) {
              __socket.emit(MY_CODE_IS, {
                code: user_code_small,
                installation: INSTALLATION_CODE,
                id: actual_user_id,
                hidden_user: 0,
                version: 3,
                encripted: true,
              });
            }
            break;
          }
          case messageTypes.DISCONNECT:
            __socket.removeAllListeners();
            __socket = null;
            init(store);
            break;
          default:
            break;
        }
      });
    });
};

export const emit = (type, payload) => __socket.emit(type, payload);

export function reconnect_node(count) {
  if (count >= MAX_ATTEMPTS_TO_RECONNECT) return;

  if (__socket && __socket.socket) {
    const newCount = count + 1;
    __socket.socket.connect(newCount);
  }
}

export function emitNotificationToNode(type, data) {
  if (!__node_code) return;

  const data_json = JSON.stringify(data);

  if (__socket) {
    __socket.emit(type, data_json);
  }
}

export function joinInNodeRoom(type, id) {
  try {
    if (typeof (__socket) !== 'undefined') {
      emitNotificationToNode(JOIN_IN_ROOM, { type, id });
    }
  } catch (ex) {
    console.error(ex);
  }
}

export function leaveFromNodeRoom(type, id) {
  try {
    if (typeof (__socket) !== 'undefined') {
      emitNotificationToNode(LEAVE_FROM_ROOM, { type, id });
    }
  } catch (ex) {
    console.error(ex);
  }
}

export function sendNotificationToRoom(room, message, data) {
  emitNotificationToNode(messageTypes.NOTIFICATION_TO_ROOM, { room, req_message: message, ...data });
}



// WEBPACK FOOTER //
// ./src/modules/socket/actions.js